module.exports = __webpack_public_path__ + "static/media/24 Side Control.4ca72f27.jpg";